var _rect, _line, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfiniteKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 141,
    viewBox: "0 0 265 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.0773,
    y: 2.63922,
    width: 136.361,
    height: 136.361,
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 67.8273,
    x2: 60.1546,
    y2: 67.8273,
    stroke: "#275EB8",
    strokeWidth: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 116.294,
    y: 55.7758,
    width: 77.2087,
    height: 24.0722,
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfiniteKey);
export default __webpack_public_path__ + "static/media/infinite_key.f22b155bc81286536a86fc4442412c36.svg";
export { ForwardRef as ReactComponent };